'use client';

import { useEffect, useRef } from 'react';
import Lenis from 'lenis';

export default function SmoothScroll() {
  const lenisRef = useRef<Lenis | null>(null);
  const rafIdRef = useRef<number | null>(null);

  useEffect(() => {
    // 1. Инициализируем Lenis ровно один раз
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      touchMultiplier: 2,
    });

    lenisRef.current = lenis;

    // 2. Создаем ЕДИНСТВЕННЫЙ цикл requestAnimationFrame
    function raf(time: number) {
      lenis.raf(time);
      rafIdRef.current = requestAnimationFrame(raf);
    }
    rafIdRef.current = requestAnimationFrame(raf);

    // 3. Обработчик блокировки: используем встроенные stop() и start()
    const handleLock = (e: Event) => {
      const { isLocked } = (e as CustomEvent).detail;
      if (isLocked) {
        lenis.stop(); // Ставим скролл на паузу
      } else {
        lenis.start(); // Снимаем с паузы
      }
    };

    window.addEventListener('lenis-lock', handleLock as EventListener);

    // 4. Очистка при размонтировании компонента (например, при переходе на другую страницу)
    return () => {
      window.removeEventListener('lenis-lock', handleLock as EventListener);
      
      // Обязательно убиваем цикл анимации, чтобы не было утечек памяти
      if (rafIdRef.current !== null) {
        cancelAnimationFrame(rafIdRef.current);
      }
      
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  return null;
}